import React, { useState } from 'react'
import { Icon, Modal, Popover, Checkbox } from "antd"
import * as applyBrandingForAllItems from "../../../configs/applyBrandingForAllItems"

function AttachTagDetail(props) {
    const { loading, processingOrder, reset, onMarkTagged } = props
    const { brand, brandKit, thankCard, barcode = {}, meta = {} } = processingOrder || {}
    // const { set_items = [] } = meta || {}
    // const setItemOptons = Array.isArray(set_items) && !!set_items.length ? set_items.map((i) => ({
    //     label: <span style={{ fontWeight: 700, fontSize: 20 }}>{i.name}</span>,
    //     value: i._id,
    // })) : []
    // const { tags = [] } = { ...barcode }
    // const [hoverOrder, setHoverOrderState] = useState(false)
    const [visibleImage, setVisibleImage] = useState(null)
    const [imageName, setImageName] = useState('')
    // const [itemsSetSelected, setItemsSetSelected] = useState([])
    // const [checkedAllSetItems, setCheckedAllSetItems] = useState(false)

    // const isAppliedBrandingForAllItems = applyBrandingForAllItems.isSupport(processingOrder && processingOrder.barcode)
    // const isThankCard = () => !!(thankCard && thankCard.length)
    // const isBrandKit = () => !!(brandKit && brandKit.length)
    // const isMadeInVN = tags.includes('made_vn')
    // const isNoProofTag = tags.includes('no_proof')
    // const { is_cheap_product = false } = sku || {}
    // const disabledBtnMark = (Array.isArray(set_items) && set_items.length ? !checkedAllSetItems : false)

    // const maxCols = ({
    //     1: 12,
    //     2: 6,
    //     3: 4
    // })[totalItems] || 4

    const handleMarkTagged = () => {
        onMarkTagged()
    }

    const handleShowModal = (image, name) => {
        setVisibleImage(image)
        setImageName(name)
    }

    const handleHideModal = () => {
        setVisibleImage(null)
        setImageName('')
    }

    const { preview_image, procedure, designFront, designBack, designLeft, designRight, designHood, designSleeves } = processingOrder
    const arrPrintFileImg = [
        { name: 'Front', image: designFront },
        { name: 'Back', image: designBack },
        { name: 'Left', image: designLeft },
        { name: 'Right', image: designRight },
        { name: 'Sleeves', image: designSleeves },
        { name: 'Hood', image: designHood },
    ].filter(item => item.image)

    return (
        <div className="MarkPackagedPageDetails">
            <div className="BasicInfo d-flex flex-wrap justify-content-between mt-2 mb-2">
                <div className="leftContent">
                    <span className="InfoType">{processingOrder.type}</span>
                    <span className="InfoSize badge bg-secondary">{processingOrder.size}</span>
                    <span className="InfoSize badge bg-secondary">{processingOrder.color}</span>
                    {
                        brand && brand.name && <span className="InfoBrand badge text-bg-danger">{brand.name}</span>
                    }
                    {/* <p><strong>{totalItems}</strong> đơn cần đánh dấu</p> */}
                </div>
                
            </div>
            <div className={['ListOrders', 'row'].join(' ')}>
                {
                    procedure === '2D' ? (
                        <div className={`Order mb-4 col-md-12 d-flex flex-wrap`} key={processingOrder._id}>
                            {arrPrintFileImg.length > 0 && arrPrintFileImg.map((item, index) => (
                                <div key={`printFileImg_${index}`} className="OrderInner" style={arrPrintFileImg.length > 1 ? { width: '50%', padding: 10, background: 'white', zIndex: 11 } : { width: '100%' }}>
                                    <div
                                        className="ImagePreview position-relative h-100"
                                        key={`${processingOrder._id}_${index}`}
                                    >
                                        <h3>{item.name}:</h3>
                                        <img src={item.image} className='previewImage' alt='preview' />
                                        <div className='Actions d-flex justify-content-center align-items-center position-absolute'>
                                            <span className='Icon cursor-pointer mr-2' onClick={() => handleShowModal(item.image, item.name)}><Icon type='eye' /></span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <React.Fragment>
                            <div className={`Order mb-4 col-md-12 pr-0`} key={processingOrder._id}>
                                <div className="OrderInner">
                                    {
                                        preview_image && <div className="ImagePreview position-relative">
                                            <img src={preview_image} className='previewImage' alt='preview' />
                                            <div className='Actions d-flex justify-content-center align-items-center position-absolute'>
                                                <span className='Icon cursor-pointer mr-2' onClick={() => handleShowModal(preview_image, '')}><Icon type='eye' /></span>
                                            </div>
                                            <div className="font-weight-bold position-absolute" style={{ top: '-25px', right: 0, color: 'black' }}>File print</div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </React.Fragment>
                    )
                }
            </div>
            <Modal
                visible={!!visibleImage}
                closable={false}
                centered={true}
                footer={null}
                width={1200}
                onCancel={handleHideModal}
            >
                <div className="Previewer">
                    {imageName && <h3>{imageName}:</h3>}
                    {visibleImage && <img src={visibleImage} alt='preview' className='d-block m-auto' />}
                </div>
            </Modal>
            <div className="Actions d-flex justify-content-between align-items-center mb-4">
                <div className="btnCancel">
                    <button type="button" className="btn btn-secondary" onClick={reset}>Hủy</button>
                </div>
                <div className="d-flex align-items-center">
                    <div className="btnMarkPackaged">
                        <button
                            type="button"
                            className="btn btn-primary Mark"
                            onClick={handleMarkTagged}
                            // disabled={disabledBtnMark}
                        >
                            Đánh dấu gắn tag mác
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AttachTagDetail